import typeToReducer from 'type-to-reducer';

const initialState = {
};
export default typeToReducer({
}, initialState);



/** WEBPACK FOOTER **
 ** F:/agent-C107052-04/_work/417/s/Tube.Frontend/src/containers/App/screens/Login/screens/CompanySelection/reducers/index.js
 **/